import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useMutateDeleteReports() {
    const { oktaAuth } = useOktaAuth();

    const deleteReports = async (requestData) => {
        const accessToken = oktaAuth.getAccessToken();

        const requestBody = {
            rpid: requestData.rpid,
            userId: requestData.userId
        };

        const response = await axios.post(
            `api/ThirdPartyReceivable/DeleteReportsForCurrentMonth`,
            requestBody,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
            }
        );

        return response.data;
    };

    return useMutation({
        mutationFn: deleteReports,
    });
}
